/*! Copyright (c) 2016 Naufal Rabbani (http://github.com/BosNaufal)
* Licensed Under MIT (http://opensource.org/licenses/MIT)
*
* React File Base64 - Version@1.0.0
*
*/

import React from 'react';
export default class FileInput extends React.Component {

  handleChange(e) {
    var _this=this

    // get the files
    let files = e.target.files;

    // Process each file
    var allFiles = [];
    for (var i = 0; i < files.length; i++) {
      let file = files[i];

      // Make new FileReader
      let reader = new FileReader();

      // Convert the file to base64 text
      reader.readAsDataURL(file);

      // on reader load somthing...
      reader.onload = () => {
        // Make a fileInfo Object
        let fileInfo = {
          filename: file.name,
          content_type: file.type,
          byte_size: file.size,
          file: reader.result,
          name: _this.props.input.name.split('][').slice(-1)[0].split('_')[0]
        };

        // Push it to the state
        allFiles.push(fileInfo);

        // If all files have been proceed
        if (allFiles.length === files.length) {
          // Apply Callback function
          const { 
            props: { multiple, onChangeHook, input }, 
          } = _this;
          
          if (multiple){
            input.onChange(allFiles)
            if(onChangeHook)
              onChangeHook(allFiles)
          }
          else{
            input.onChange(allFiles[0])
            if(onChangeHook)
              onChangeHook(allFiles[0])
          }
        }
      }; // reader.onload
    } // for
  }

  resetUpload() {
    //document.getElementById(this.props.id).value = '';
  }

  render() {
    const { label, labelClasses, imageClasses, wrapperClasses } = this.props
    return (
      <div className={`${wrapperClasses}`}>
        <label className={labelClasses}>
          {label && label}
          <input
            type="file"
            onChange={this.handleChange.bind(this)}
            onClick={this.resetUpload.bind(this)}
            {...this.props}
            className="d-none"
            multiple
          />
          {this.props.input && this.props.input.value && this.props.input.value.file ?
            <div className="border border-light text-center text-muted">
              <embed className={`${imageClasses}`} src={this.props.input.value.file.url || this.props.input.value.file}  style={{objectFit: "fit"}} ></embed>
              <p className="mb-0 py-2 px-5 bg-light pointer"><i className="la la-sm la-cloud-upload text-muted"/> Choose file</p>
            </div>
            :
            <div className="border border-light bg-light py-7 px-5 text-center text-muted pointer">
              <i className="la la-cloud-upload text-muted"/>
              <p>Browse from computer to upload file.</p>
            </div>
          }
        </label>
      </div>
    );
  }
}

